<script>
  import notify from "../../../../../../Script/notify"
  import { emailRegex } from "../../../../../../Script/regex"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  export let ccList = []

  let ccAddress = ""

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  const getInitial = (email) => {
    return email.charAt(0).toUpperCase()
  }

  const addCc = () => {
    try {
      ccAddress = ccAddress.trim()
      if (!ccAddress) throw "Kindly provide a email address to add"
      if (!emailRegex.test(ccAddress)) throw "Kindly provide a valid email address"

      if (!ccList.some((e) => e.email === ccAddress)) {
        ccList = [...ccList, { email: ccAddress, initial: getInitial(ccAddress) }]
      }
      ccAddress = ""
    } catch (error) {
      console.error(error)
      closeNotification.close()
      closeNotification = notify.danger(error)
    }
  }

  const removeCc = (email) => {
    ccList = ccList.filter((e) => e.email !== email)
  }

  const clearCc = () => {
    ccList = []
  }

  const close = () => {
    dispatch("close")
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div on:click|self={close} class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm">
  <div class="relative w-full max-w-[800px] rounded-xl bg-white p-6 shadow-2xl dark:bg-[#1c1d21] md:p-8">
    <button on:click={close} class="absolute right-6 top-6 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white">
      <i class="fa-solid fa-xmark fa-lg" />
    </button>

    <div class="mb-8 flex items-start gap-4">
      <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-blue-100 dark:bg-[#243048]">
        <i class="fa-solid fa-envelope text-2xl text-blue-500 dark:text-white" />
      </div>
      <div>
        <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Add Cc Recipients</h2>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">To receive a copy of every email sent after the bulk publishing process, enter the email addresses of the additional recipients in the Cc Recipients field.</p>
      </div>
    </div>

    <!-- CC Column -->
    <div class="flex flex-col gap-4 border-t border-gray-200 pt-6 dark:border-[#272B31] md:flex-row md:gap-8">
      <form class="w-full" on:submit|preventDefault={addCc}>
        <label for="cc" class="mb-2 block text-sm font-medium text-gray-800 dark:text-white">Add Cc Address</label>
        <div class="flex gap-2">
          <div class="relative flex-1">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <i class="fa-solid fa-envelope text-gray-400" />
            </div>
            <input id="cc" name="cc" bind:value={ccAddress} type="email" placeholder="Enter Cc Address" class="block w-full rounded-md border border-gray-300 bg-gray-50 p-2.5 pl-10 text-sm text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-[#2B2F36] dark:bg-[#141518] dark:text-white dark:placeholder-[#4d515a]" />
          </div>
          <button type="submit" disabled={!ccAddress} class="flex items-center gap-2 rounded-md bg-blue-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-600 disabled:opacity-50 dark:bg-[#2381ff]">
            <i class="fa-solid fa-plus" />
            Add
          </button>
        </div>
        <p class="mt-2 text-xs text-gray-500 dark:text-[#595d66]">Please Enter or Click "Add" to include Email.</p>
      </form>

      <div class="flex w-full flex-col gap-3">
        <div class="flex items-center justify-between">
          <span class="text-sm font-medium text-gray-800 dark:text-white">Cc Recipients ({ccList.length})</span>
          <button on:click={clearCc} class="flex items-center gap-2 text-xs text-red-500 transition-colors hover:text-red-600 dark:text-[#dc4c64] dark:hover:text-red-400">
            <i class="fa-solid fa-trash-can" />
            Clear All
          </button>
        </div>

        <div class="flex max-h-[160px] min-h-[160px] flex-col gap-2 overflow-y-auto pr-1">
          {#each ccList as item}
            <div class="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 p-2.5 transition-colors dark:border-[#272B31] dark:bg-[#16181d]">
              <div class="flex items-center gap-3">
                <div class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-500 text-xs font-medium text-white dark:bg-[#2381ff]">
                  {item.initial}
                </div>
                <span class="text-sm text-gray-600 dark:text-white">{item.email}</span>
              </div>
              <button on:click={() => removeCc(item.email)} class="text-gray-400 transition-colors hover:text-red-500">
                <i class="fa-solid fa-xmark" />
              </button>
            </div>
          {:else}
            <div class="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 p-2.5 transition-colors dark:border-[#272B31] dark:bg-[#16181d]">
              <div class="flex items-center gap-3">
                <div class="flex h-6 w-6 items-center justify-center rounded-full bg-red-200 text-xs font-medium text-white dark:bg-red-500">
                  <span>
                    <i class="fa-solid fa-xmark" />
                  </span>
                </div>
                <span class="text-sm text-gray-600 dark:text-[#72767f]">No recipients found</span>
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>

    <div class="mt-8 w-full border-t border-gray-200 pt-6 dark:border-[#272B31]">
      <button on:click={close} class="ml-auto flex items-center gap-2 rounded-md bg-green-500 px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-green-600 dark:bg-[#22c55e] dark:hover:bg-[#16a34a]">
        <i class="fa-solid fa-reply" />
        Back
      </button>
    </div>
  </div>
</div>
